import { render, staticRenderFns } from "./bindwx.vue?vue&type=template&id=d8ef58bc&scoped=true"
import script from "./bindwx.vue?vue&type=script&lang=js"
export * from "./bindwx.vue?vue&type=script&lang=js"
import style0 from "./bindwx.vue?vue&type=style&index=0&id=d8ef58bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ef58bc",
  null
  
)

export default component.exports